/**
 * The signed-in admin's own account.
 *
 * `console/me`, NOT `auth/profile`: that route is `auth: 'user'` and refuses a
 * caller without a student or teacher persona, which most admins are. And NOT
 * `console/users/{id}`, which is the authority to administer someone else.
 * "My own account" is neither, so it has its own route — see
 * functions/src/admin/auth/adminSelfProfile.ts.
 */
import { fetchWithAdmin } from './fetchHelper';

export interface MyProfile {
  id: string;
  name?: string;
  shortName?: string;
  email?: string;
  roles?: string[];
  ring?: string;
  /** False when this sign-in has no user record to edit — the platform
   *  super-admin authenticates against a seeded credential rather than a
   *  document. A state the page renders, not an error it reports. */
  editable: boolean;
}

/** What an admin may change about themselves. Deliberately just the two: the
 *  user record also carries grade, target exams and study-day preferences,
 *  which describe a STUDENT and would be noise here. */
export interface MyProfileUpdate {
  name?: string;
  shortName?: string;
}

export const profileApi = {
  get: () => fetchWithAdmin<{ user: MyProfile }>('/console/me').then(r => r.user),

  update: (data: MyProfileUpdate) =>
    fetchWithAdmin<{ user: MyProfile }>('/console/me', {
      method: 'PUT',
      body: JSON.stringify(data),
    }).then(r => r.user),
};
